import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            redirect: '/project/list'
        },

        // 登陆
        {
            path: '/login',
            name: 'Login',
            component: resolve => require(['@/view/login/login'], resolve)
        },

        // 项目
        {
            path: '/project',
            component: resolve => require(['@/view/project/index'], resolve),
            children: [
                {
                    path: '/',
                    redirect: 'list',
                },
                {
                    path: 'list',
                    name: 'ProjectListActive',
                    component: resolve => require(['@/view/project/list-active'], resolve)
                },
                {
                    path: 'filed-list',
                    name: 'ProjectListFiled',
                    component: resolve => require(['@/view/project/list-filed'], resolve)
                },
                {
                    path: 'detail',
                    component: resolve => require(['@/view/project/detail'], resolve),
                    children: [
                        {
                            path: 'recruitment',
                            name: 'ProjectDetailRecruitment',
                            component: resolve => require(['@/view/project/detail-before-execution'], resolve)
                        },
                        {
                            path: 'interview',
                            name: 'ProjectDetailInterview',
                            component: resolve => require(['@/view/project/detail-before-execution'], resolve)
                        },
                        {
                            path: 'training',
                            name: 'ProjectDetailTraining',
                            component: resolve => require(['@/view/project/detail-before-execution'], resolve)
                        },
                        {
                            path: 'execution',
                            name: 'ProjectDetailExecution',
                            component: resolve => require(['@/view/project/detail-execution'], resolve)
                        },
                        {
                            path: 'ending',
                            name: 'ProjectDetailEnding',
                            component: resolve => require(['@/view/project/detail-ending'], resolve)
                        },
                    ]
                },
                {
                    path: 'settings',
                    name: 'ProjectSettings',
                    component: resolve => require(['@/view/project/settings'], resolve)
                },
                {
                    path: 'task',
                    component: resolve => require(['@/view/project/task'], resolve),
                    children: [
                        {
                            path: '/',
                            redirect: '/404'
                        },
                        {
                            path: 'add',
                            name: 'ProjectTaskAdd',
                            component: resolve => require(['@/view/project/task-add'], resolve)
                        },
                        {
                            path: 'edit',
                            name: 'ProjectTaskEdit',
                            component: resolve => require(['@/view/project/task-add'], resolve)
                        },
                        {
                            path: 'detail',
                            name: 'ProjectTaskDetail',
                            component: resolve => require(['@/view/project/task-detail'], resolve)
                        }
                    ]
                }
            ]
        },

        // 大使
        {
            path: '/ambassador',
            component: resolve => require(['@/view/ambassador/index'], resolve),
            children: [
                {
                    path: '/',
                    redirect: 'list',
                },
                {
                    path: 'list',
                    name: 'AmbassadorList',
                    component: resolve => require(['@/view/ambassador/list'], resolve)
                },
                {
                    path: 'detail',
                    name: 'AmbassadorDetal',
                    component: resolve => require(['@/view/ambassador/detail'], resolve)
                }
            ]
        },

        // 客户
        {
            path: '/customer',
            name: 'Customer',
            component: resolve => require(['@/view/customer/index'], resolve)
        },
        //分析页面
        {
            path: '/analysis/:active',
            name: 'Analysis',
            component: resolve => require(['@/view/analysis/index'], resolve)
        },

        // 人才库
        {
            path: '/talents',
            name: 'Talents',
            component: resolve => require(['@/view/talents/list'], resolve)
        },

        //转化跟踪
        {
            path: '/conversion',
            name: 'Conversion',
            component: resolve => require(['@/view/conversion/list'], resolve)
        },

        // 落地页
        {
            path: '/landing',
            component: resolve => require(['@/view/landing/index'], resolve),
            children: [
                {
                    path: '/',
                    name: 'Landing',
                    redirect: 'list/landing',
                },
                {
                    path: 'list/:active',
                    name: 'LandingList',
                    component: resolve => require(['@/view/landing/list'], resolve)
                },
                {
                    path: 'add',
                    name: 'LandingAdd',
                    component: resolve => require(['@/view/landing/landing-edit'], resolve)
                },
                {
                    path: 'edit',
                    name: 'LandingEdit',
                    component: resolve => require(['@/view/landing/landing-edit'], resolve)
                },
                {
                    path: 'config_form',
                    name: 'LandingconfigForm',
                    component: resolve => require(['@/view/landing/unit-pro-form'], resolve)
                }
            ]
        },

        // 404
        {
            path: '/404',
            name: '404',
            component: resolve => require(['@/view/common/404'], resolve)
        },

        // 全局重定向
        {
            path: '*',
            redirect: '/404'
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});



// WEBPACK FOOTER //
// ./src/router/index.js